import React, { useEffect, useState, FC } from 'react'
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api'
import styles from 'styles/components/map.module.scss'
import { GOOGLE_MAP_API_KEY } from 'constants/map'
import { Caution } from 'components/Typography'

const containerStyle = {
  aspectRatio: '343/164',
  width: '100%',
}

const options = {
  disableDefaultUI: true,
}

type Props = {
  center: LatLng
  position: LatLng
  handlePosition: (lat: number, lng: number) => void
}

type LatLng = {
  lat: number
  lng: number
}

const Map: FC<Props> = (props) => {
  const { center, position, handlePosition } = props
  const [mapRef, setMapRef] = useState<google.maps.Map>()

  const handleOnLoad = (map: google.maps.Map) => {
    setMapRef(map)
  }

  const handleCenterChanged = () => {
    if (mapRef) {
      const newCenter = mapRef.getCenter()
      const lat = newCenter?.lat()
      const lng = newCenter?.lng()
      if (!lat || !lng) return
      handlePosition(lat, lng)
    }
  }

  if (center.lat === 0 && center.lng === 0) {
    return (
      <div className={styles.blank}>
        <Caution caution={'住所を入力してください'} />
      </div>
    )
  }

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAP_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        options={options}
        center={center}
        zoom={17}
        onLoad={handleOnLoad}
        onCenterChanged={handleCenterChanged}
      >
        <Marker position={position} icon={'/icon/orange/map_pin.svg'} />
      </GoogleMap>
    </LoadScript>
  )
}

export default Map
